import React from 'react';

import gettext from '@eb/gettext';

import { Button } from '@eb/eds-button';
import { ModalBody } from '@eb/eds-modal';
import { WhoopsIllustration } from '../../resources/whoopsIllustration';

import { CTA_ACTION, RETRY_MAX_ATTEMPT } from '../../constants';

import '../../common.scss';

export interface WhoopsPageProps {
    isEventbriteTLD: boolean;
    onCTAClick: (action: CTA_ACTION) => void;
    retryAttempts: number;
}

export const WhoopsPage: React.FunctionComponent<WhoopsPageProps> = ({
    isEventbriteTLD,
    onCTAClick,
    retryAttempts,
}) => {
    let ctaButton = (
        <Button
            __containerClassName="eds-align--center"
            data-spec="whoops-try-again-btn"
            onClick={() => onCTAClick(CTA_ACTION.RELOAD)}
            size="responsive"
            style="fill"
        >
            {gettext('Please try again')}
        </Button>
    );

    if (isEventbriteTLD && retryAttempts >= RETRY_MAX_ATTEMPT) {
        ctaButton = (
            <Button
                __containerClassName="eds-align--center"
                data-spec="whoops-go-listing"
                onClick={() => onCTAClick(CTA_ACTION.GO_TO_LISTING_PAGE)}
                size="responsive"
                style="link"
            >
                {gettext('Go to the event page')}
            </Button>
        );
    }

    return (
        <ModalBody>
            <div className="content-centered">
                <div className="eds-text--center">
                    <WhoopsIllustration />
                    <div className="eds-text-hs eds-l-mar-bot-2">
                        {gettext('Whoops!')}
                    </div>
                    <div className="eds-text-bm eds-l-mar-bot-4 eds-text-color--ui-600">
                        {gettext('Something went wrong loading this page.')}
                    </div>
                    {ctaButton}
                </div>
            </div>
        </ModalBody>
    );
};
